import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
import ConnectedEventProfileImage from "../../common/EventProfileImage";
import "./FormStatusImage.scss";

const FormStatusImage = ({ avatar = "" }) => {
    // Set the default image to the box icon with a heart in it
    let image = (
        <Icon
            className="form-status-image__icon"
            glyph="box-heart-solid"
            type="FontAwesome"
        />
    );

    // If the user has uploaded an event profile image
    if (avatar) {
        image = <ConnectedEventProfileImage />;
    }

    return <div className="form-status-image">{image}</div>;
};

FormStatusImage.propTypes = {
    avatar: PropTypes.string,
};

export default FormStatusImage;
